//#region src/error-codes.ts
var RUNTIME_001 = "RUNTIME-001";
var RUNTIME_002 = "RUNTIME-002";
var RUNTIME_003 = "RUNTIME-003";
var RUNTIME_004 = "RUNTIME-004";
var RUNTIME_005 = "RUNTIME-005";
var RUNTIME_006 = "RUNTIME-006";
var RUNTIME_007 = "RUNTIME-007";
var RUNTIME_008 = "RUNTIME-008";
var RUNTIME_009 = "RUNTIME-009";
var RUNTIME_010 = "RUNTIME-010";
var RUNTIME_011 = "RUNTIME-011";
var RUNTIME_012 = "RUNTIME-012";
var TYPE_001 = "TYPE-001";
var BUILD_001 = "BUILD-001";
var BUILD_002 = "BUILD-002";
//#endregion
exports.BUILD_001 = BUILD_001;
exports.BUILD_002 = BUILD_002;
exports.RUNTIME_001 = RUNTIME_001;
exports.RUNTIME_002 = RUNTIME_002;
exports.RUNTIME_003 = RUNTIME_003;
exports.RUNTIME_004 = RUNTIME_004;
exports.RUNTIME_005 = RUNTIME_005;
exports.RUNTIME_006 = RUNTIME_006;
exports.RUNTIME_007 = RUNTIME_007;
exports.RUNTIME_008 = RUNTIME_008;
exports.RUNTIME_009 = RUNTIME_009;
exports.RUNTIME_010 = RUNTIME_010;
exports.RUNTIME_011 = RUNTIME_011;
exports.RUNTIME_012 = RUNTIME_012;
exports.TYPE_001 = TYPE_001; //# sourceMappingURL=error-codes.cjs.map
